module.exports = __webpack_public_path__ + "static/img/5-5.a9f19c3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/2/eng/5-5.png
// module id = zTsB
// module chunks = 0